module.exports = __webpack_public_path__ + "static/media/graph-background.2410c633.svg";


//////////////////
// WEBPACK FOOTER
// ./src/routes/Home/assets/graph-background.svg
// module id = 757
// module chunks = 20